<template>
  <div class="text-grey-lightest">
    <button @click="fireAway()" class="hover:text-white focus:text-white underline">
      {{ buttonText }}
    </button>
    <p v-show="!skipAutoFire"><small>{{ countdownText }}</small></p>
  </div>
</template>

<script>
import { NODE_ENV } from '../../env';
import { log } from '../../log';

export default {
  name: 'HelperCountdownToFunction',
  props: {
    buttonText: String,
    timerComplete: String,
    redirectOnTimerEnd: {
      type: Boolean,
      default: false,
    },
    skipAutoFire: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    timer: 8,
  }),
  computed: {
    computedTimerPrefix() {
      return this.redirectOnTimerEnd
        ? this.$t('regWizPopUp.routes.success.countdown.error.prefix', [this.timer])
        : this.$t('regWizPopUp.automaticallyClosingIn', [this.timer]);
    },
    computedTimerComplete() {
      return this.timerComplete ?? this.$t('regWizPopUp.byeBye');
    },
    countdownText() {
      return this.timer > 1
        ? this.computedTimerPrefix
        : this.computedTimerComplete;
    },
  },
  methods: {
    fireAway() {
      this.$emit('fire');
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
          return false;
        }
        // stop timer, FIRE function
        clearInterval(this.timerInterval);
        return NODE_ENV === 'development' || this.skipAutoFire
          ? log.debug('❌ [SKIP AUTO FIRE] ❌')
          : this.fireAway();
      }, 1000);
    },
  },
  created() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval); // prevent firing after navigating away from page
  },
};
</script>
